import React from "react"
import { connect } from "react-redux"
import { injectStripe } from "react-stripe-elements"
import { getCurrentUser } from "redux/ducks/User"
import { createRequest } from "utils/request-helper"
import { submitButtonStyle } from "components/Form/FormFields/SubmitButton"
import CardSection from "./card-section"
import glamorous from "glamorous"

class CheckoutForm extends React.Component {
  state = {
    formError: undefined,
  }

  handleSubmit = ev => {
    ev.preventDefault()

    this.props.stripe.createToken().then(({ token }) => {
      createRequest(
        {
          method: "PATCH",
          route: `camps/${this.props.currentUser.camp.id}`,
          data: {
            data: {
              type: "camps",
              attributes: {
                billing_customer_token: token.id,
                billing_card_type: token.card.brand,
                billing_card_last_4: token.card.last4,
                billing_card_expiration:
                  token.card.exp_month + "/" + token.card.exp_year,
                subscribed_camps_and_campers: true,
              },
            },
          },
        },
        response => {
          this.props.getCurrentUser()
          this.props.history.push("/")
        },
        error => console.log(error)
      )
    })
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        {this.state.formError && (
          <div>
            There was an error updating your camp. Please try again later.
          </div>
        )}

        <CardSection />

        <ButtonContainer>
          <button style={submitButtonStyle}>Confirm order</button>
        </ButtonContainer>
      </form>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

const mapDispatchToProps = dispatch => ({
  getCurrentUser: () => dispatch(getCurrentUser()),
})

export default injectStripe(
  connect(mapStateToProps, mapDispatchToProps)(CheckoutForm)
)

const ButtonContainer = glamorous.div({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
})



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampBilling/checkout-form.js